import React from "react";
import CTable from "components/common/Table";
import Text from "components/common/Text";

const FeedbackUnsuccessfulTable = ({ data, loading, toggleDrawer,  page,
  limit,
  totalCount,onPageChange }) => {
  const columns = [
    {
      field: "customer_name",
      headerName: "Customer name",
    },
    {
      field: "charging_station_name",
      headerName: "Charging Station",
    },
    {
      field: "charging_network",
      headerName: "Name of Network",
    },
    {
      field: "failure_reason",
      headerName: "Problem",
    },
    {
      field: "feedback",
      headerName: "Feedback",
    },
    {
      field: "reply",
      headerName: "Reply to feedback",
      valueGetter: (v, d) => {
        return (
          <>
            {
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Text style={{ fontSize: "15px" }}>Reply</Text>
                <img
                  onClick={() =>
                    toggleDrawer({
                      id: d.id,
                      review: d.feedback,
                      customerName: d.customer_name,
                      problem: d.failure_reason,
                      reply_to_feedback:d.reply_to_feedback,
                      replyTime:d.updated_at
                    })
                  }
                  src="../images/replyicon.svg"
                  alt="reply"
                  style={{ width: "27px" }}
                ></img>
              </div>
            }
          </>
        );
      },
    },
  ];

  return (
    <CTable
    
      isLoading={loading?.isLoading}
      pagination={true}
      columns={columns}
      data={data ?? []}
      page={page}
      rowsPerPage={limit}
      count={totalCount}
      onPageChange={onPageChange}
    />
  );
};

export default FeedbackUnsuccessfulTable;
